<template>
    <div class="w-full h-full grid place-items-center">
        <Icon name="svg-spinners:blocks-shuffle-2" class="!w-16 !h-16 text-primary" />
    </div>
</template>

<script lang="ts" setup></script>

<style></style>
